import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { MyMCheckBox } from '../ui-elements/MyMCheckBox';

/** MyMine Version2.1 新規作成
 * ValidatableCheckBoxList Component
 * @param {any} param0
 * @returns
 */
export const ValidatableCheckBoxList = (props) => {
  const {
    controllerName,
    keyValueList,
    checkedList,
    control,
    rules,
    formState,
    onChange,
    trigger,
    handleValid = true,
    // 2025.7.7 MyMine Version3.0対応 Add Start
    checkboxProps,
    isVertical,
    renderOptionSuffixItem
    // 2025.7.7 MyMine Version3.0対応 Add End
  } = props;

  useEffect(() => {
    if (formState.isSubmitted && trigger) {
      trigger(controllerName)
    }
    if (!handleValid && trigger) {
      trigger(controllerName)
    }
  }, [checkedList])

  return (
    <FormControl error={formState.errors[controllerName] ? true : false} sx={{ width: "100%" }}>
      <Controller
        control={control}
        name={controllerName}
        defaultValue={checkedList}
        render={({ field: { ref, ...field } }) =>
          <FormGroup className={isVertical ? 'flex-column' : 'flex-row'}>
            {
              keyValueList.map((item) => (
                // 2025.7.7 MyMine Version3.0対応 Modify Start
                <React.Fragment key={item.Key}>
                  <MyMCheckBox
                    label={item.Value}
                    labelPlacement="start"
                    checked={checkedList.includes(item.Key)}
                    onChange={(e) => onChange(e, item)}
                    // 2025.7.7 MyMine Version3.0対応 Add Start
                    {...checkboxProps}
                    // 2025.7.7 MyMine Version3.0対応 Add End
                  />
                  {renderOptionSuffixItem && renderOptionSuffixItem(item)}
                </React.Fragment>
                // 2025.7.7 MyMine Version3.0対応 Modify End
              ))
            }
          </FormGroup>
        }
        rules={rules}
      />
      <FormHelperText>{formState.errors[controllerName]?.message}</FormHelperText>
    </FormControl>
  );
}
